module.exports = __webpack_public_path__ + "img/airplane-flying-in-cloudy-sky-crop.f7f40482.jpg";